import {
  Bell,
  CalendarDays,
  Globe2,
  History,
  House,
  LayoutGrid,
  Megaphone,
  PlugZap,
  Settings,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  /** Path prefixes this item owns; the longest match wins, so
   *  /settings/google lights Google 연결 and not 설정. */
  match: string[]
  /** 0 = the morning's work, 1 = what is looked into, 2 = the setup behind it. */
  group: 0 | 1 | 2
  /** `attention`: the count of things to check. `unread`: unread alerts. */
  badge?: 'attention' | 'unread'
}

/** The sidebar, in order (plan 1-2). Nine items in three groups. */
export const NAV: NavItem[] = [
  { to: '/', label: '오늘', icon: House, match: ['/'], group: 0, badge: 'attention' },
  { to: '/calendar', label: '달력', icon: CalendarDays, match: ['/calendar'], group: 0 },
  { to: '/alerts', label: '알림', icon: Bell, match: ['/alerts'], group: 0, badge: 'unread' },
  { to: '/apps', label: '앱', icon: LayoutGrid, match: ['/apps'], group: 1 },
  { to: '/countries', label: '국가', icon: Globe2, match: ['/countries'], group: 1 },
  { to: '/campaigns', label: '캠페인', icon: Megaphone, match: ['/campaigns'], group: 1 },
  { to: '/settings/google', label: 'Google 연결', icon: PlugZap, match: ['/settings/google'], group: 2 },
  { to: '/jobs', label: '작업 기록', icon: History, match: ['/jobs'], group: 2 },
  { to: '/settings', label: '설정', icon: Settings, match: ['/settings'], group: 2 },
]

/** The phone's bottom tabs; everything else is under 더보기. 캠페인 is not a
 *  tab: it stays empty until Google Ads access is approved. */
export const TAB_PATHS = ['/', '/calendar', '/apps', '/countries']

function owns(prefix: string, pathname: string): boolean {
  if (prefix === '/') return pathname === '/'
  return pathname === prefix || pathname.startsWith(prefix + '/')
}

/** The path the menu lights up for: a detail opened from a page (the app
 *  drawer, a full page on a phone) belongs to that page, so an app opened from
 *  오늘 keeps 오늘 lit; a detail reached by its address falls back to its own
 *  path. */
export function navPathname(loc: { pathname: string; state?: unknown }): string {
  const bg = (loc.state as { background?: { pathname?: unknown } } | null | undefined)?.background
  return bg && typeof bg.pathname === 'string' ? bg.pathname : loc.pathname
}

/** The item a path belongs to: the longest matching prefix wins. */
export function activeNav(pathname: string): NavItem | undefined {
  let best: NavItem | undefined
  let bestLen = -1
  for (const item of NAV) {
    for (const m of item.match) {
      if (owns(m, pathname) && m.length > bestLen) {
        best = item
        bestLen = m.length
      }
    }
  }
  return best
}
